module.exports = (() => {
    $(document).ready(function () {

        $('body').on('click', '.input-group-senha [data-toggle-senha]', function (e) {
            e.preventDefault();
            let $this = $(this);
            let $inputGroupSenha = $this.closest('.input-group-senha');

            let modo = $inputGroupSenha.data('campo-modo') || 'password';
            let input = $inputGroupSenha.find('input');

            if (modo == 'password') {
                input.attr({ type: 'text' });
                modo = 'text';
                $inputGroupSenha.data('campo-modo', modo);
                return;
            }

            input.attr({ type: 'password' });
            modo = 'password';
            $inputGroupSenha.data('campo-modo', modo);
        });
    });
})();
